/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {reviewTransaction} from '../api'

export const useMutationReviewTransaction = createReactQueryMutationHook('reviewTransaction', reviewTransaction)
